import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  /* width: calc(100% - 30px); */
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
`
const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  color: #56565A;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 19px;
  border: none;
  outline: none;
  padding-bottom: 10px;
  border-bottom: 1px solid #DBDBDC;
  &:focus { /* overrides for legacy stylesheets */
    border: none;
    border-bottom: 1px solid;
    border-color: #DBDBDC !important;
    box-shadow: none !important;
  }
`

export default ({ predefined, ...rest }) => {
  return (
    <Container>
      <Input readOnly={predefined} {...rest}/>
    </Container>
  )
}
